import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Basket from './Basket';
import Picker from './Picker';
import ACEF from './AddCanvasElementFunctions';
import LangSwitcher from './LangSwitcher';
import {IconFill, IconTextAdd, IconImageAdd, IconEye, IconProducts, IconLayout, IconMenu, IconArrow  } from './Icons';
import Tip from './Tip';
import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class TopToolBar  extends Component  {

  @observable toolbarData = {
    views : {},
    show : {
      upload : true,
      layout : true,
      preview : true,
      products: true,
      text : true,
      views : true
    }
  };

  @observable trans = { };

  @observable currentView = 'layout'; // layout || preview
  @observable currentSide = 0;
  @observable siteTipShow = false;

  @observable menuOpen = false;

  @observable showBackgroundPicker = false;

  disableClickingForSomeTime = false;

  ACEF = new ACEF();


  constructor(props) {

    super(props)

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

    $(document).on('click', '.js-tools-on-off', function () {
      var box = $(this).closest('.js-tools');
      //var content = box.find('js-tools-on-off-content');

      if (box.hasClass('js-tools-open')) {
        box.removeClass('js-tools-open');
      }
      else {
        box.addClass('js-tools-open');
      }
      $(window).trigger('bodyresize');
    })


    $(window).on('SingleProject-setViews',  (e, id)=> {

     // $('.js-bf-views button').removeClass('active');
     // $('.js-bf-views').find('[data-id="' + id + '"]').addClass('active');

      this.currentSide = id;

    })

    /*
    $(document).on('click', '.js-bf-views button', function () {

      var id = $(this).attr('data-id');

      $(window).trigger('Tools-changeView', id);
      $('.js-show-layout-view').trigger('click');

    })
    */



    $(window).on('WideMode-on SingleProject-WideMode-on', function () {
      $('.bf-tools-area').addClass('wide-mode');
      $('.creator-area-container').addClass('wide-mode');
      $('body').addClass('wide-mode');
      wideModeByWidth();
    })

    $(window).on('WideMode-off SingleProject-WideMode-off', function () {
      $('.bf-tools-area').removeClass('wide-mode');
      $('.creator-area-container').removeClass('wide-mode');
      $('body').removeClass('wide-mode');
      wideModeByWidth();
    })

    $(window).on('resize', function () {
      wideModeByWidth();
    })
    wideModeByWidth();

    function wideModeByWidth() {
      if ($(window).width() < 1024) {
        $('.bf-tools-area').addClass('wide-mode');
        $('.creator-area-container').addClass('wide-mode');
      }
      else {
        if ($('body').hasClass('wide-mode')) {
          $('.bf-tools-area').addClass('wide-mode');
          $('.creator-area-container').addClass('wide-mode');
        }
        else {
          $('.bf-tools-area').removeClass('wide-mode');
          $('.creator-area-container').removeClass('wide-mode');
        }
      }
    }


    $(window).on('SingleProject-prepareViews', function (e, viewsObj) {

      var data = {};
      data.viewsObj = viewsObj;

      scope.toolbarData.views = data.viewsObj.views;

    });


  }

  upload(){

    if ( Settings.getSettingsMediaListCount < 1 )
    //if( ($('#bf-media-gallery.js-bf-media:first li').length < 1 ) )
    {
      Settings.setFirstUpload(true,true);

    }
    else
    {
      Settings.setFirstUpload(false);
    }

    if ( Settings.getSettingsFirstUploadAccepted || !Settings.getSettingsFirstUpload )
    {

      if ( Settings.getSettingsMediaListCount > 19 ) {
      //if ($('#bf-media-gallery.js-bf-media:first li').length > 49) {
        var obj = new Object();
        obj.title = "Information";
        obj.text = 'You can have only 20 images in Your media area.';
        obj.type = 'warning';
        $(window).trigger('notify', obj);
      }
      else {
        $('#bf_filemedia:first input').trigger('click');
        // $('#bf_filemedia:first input').trigger('click');
      }
      $(window).trigger('bodyresize');
    }

  }

  showLayout(){

      this.currentView = 'layout';
      $(window).trigger('Tools-showLayoutView-Animate');
      $(window).trigger('Tools-deselectLayers');
      $(window).trigger('Tools-hideCanvaTool');
  }

  showPreview(){

    this.currentView = 'preview';

    $(window).trigger('Tools-showPreviewView-Animate');
    $(window).trigger('Tools-deselectLayers');
    $(window).trigger('Tools-hideCanvaTool');

  }

  showSide(id){

    if (  this.currentSide == id || this.disableClickingForSomeTime ) return;

    this.showLayout();   
    Settings.setSettingsIsActive(false);

    this.disableClickingForSomeTime = true;
    setTimeout(()=>{
      this.disableClickingForSomeTime = false;
    },1000);

    $(window).trigger('Tools-changeView', id);
    this.currentSide = id;

  }

  addText(conf){
    this.ACEF.addText(conf);
  }

  onChoiceColor(color){

      $(window).trigger('BackgroundColor-setBackgroundColor', '#'+color);
  }

  toggleBackgroundPicker(){

    this.showBackgroundPicker = !this.showBackgroundPicker;
  }

  goToShop(){
    //window.location = window.location.host;
  }

  clickOnProducts(){
    Settings.setShowCategoryPopup(!Settings.getSettingsShowCategoryPopup);
  }

  showHideMenu(){
    this.menuOpen = !this.menuOpen;
  }

  render() {
    const t = this.t;
    let currentViewName = '';
    const data = toJS(this.toolbarData);
    const views = data.views;
    let filtered = _.filter(views,(val,key)=>{

      if ( val.id == this.currentSide ) return true;
    })
    if( filtered && filtered.length > 0 )
    {
      currentViewName = t(filtered[0].name);
    }

  
    let count = 0;

      return (
        <div className="container">        

                <div className="action-block hide-on-mobi-phone">
                  {
                    false
                      &&
                    <a href={"index.php?lang=" + this.props.dictionaryStorage.getSelectedLang} className="btn_standard">
                    <IconProducts/>
                    {t('Products')}
                    </a>
                  }
                  {
                    true
                    &&
                    <span onClick={()=>{this.clickOnProducts()}} className="btn_standard">
                      <IconProducts/>
                      {t('Products')}
                    </span>
                  }

                </div>

                <div className="action-block show-on-mobi-phone-flex topbar_menu_btn">
                  <button className="btn_standard btn_standardMenu" onClick={()=>{this.showHideMenu()}}>
                    <IconMenu />
                  </button>
                  {
                    this.menuOpen
                    &&
                    <div className="TopToolBar-menu">
                      <Tip tipPosition="left" handleClickOutside={()=>{ this.menuOpen = false; }} >
                        {
                          false
                          &&
                          <a href={"index.php?lang=" + this.props.dictionaryStorage.getSelectedLang}
                             className="btn_standard">
                            <IconProducts/>
                            {t('Products')}
                          </a>
                        }
                        {
                          true
                          &&
                          <span onClick={()=>{this.clickOnProducts()}} className="btn_standard">
                            <IconProducts/>
                                    {t('Products')}
                          </span>
                        }

                        {
                          false
                          &&
                          <LangSwitcher startLang={bf_config.currentLang} dictionaryStorage={this.props.dictionaryStorage}/>
                        }


                      <a className="btn_standard" style={{display:'none'}} onClick={ ()=> { this.goToShop()  }}>
                        <IconArrow/>
                        {t('Back to shop')}
                      </a>
                      </Tip>
                    </div>
                  }
                </div>

                <span className="sep "></span>

                <div className="action-block">
                  <button onClick={ ()=> { this.showLayout() } } className={"btn_standard   js-show-layout-view " + (this.currentView == 'layout' ? 'active-v2' : '') }>
                    <IconLayout/>
                    {t('layout')}
                  </button>
                  <button onClick={ ()=> { this.showPreview() } } className={"btn_standard js-show-preview-view " + (this.currentView == 'preview' ? 'active-v2' : '') }>
                    <IconEye/>
                    {t('preview')}
                  </button>
                </div>
                <span className="sep "></span>

                {
                  ( views.length > 1 )
                  &&
                  <div  className="action-block js-bf-views hide-on-mobi">
                    {
                      _.map(views, (data, key) => {
                        count++;
                        return (
                          <button key={key} onClick={ ()=> { this.showSide(data.id) } } className={"btn_side " + (this.currentSide == data.id ? 'active-v2' : '')} data-id={data.id}><b>{count}</b>

                            {t(data.name)}</button>
                        )
                      })
                    }

                  </div>
                }
                {
                  ( views.length > 1 )
                  &&
                  <div  className="action-block  show-on-mobi">
                    <p className="SiteButton" onClick={ ()=> { this.siteTipShow = !this.siteTipShow; } }>{currentViewName}
                    {
                      this.siteTipShow
                      &&
                      <span className="SiteTip">
                        {
                          _.map(views, (data, key) => {
                            count++;
                            return (
                              <button key={key} onClick={ ()=> {  this.showSide(data.id) } } className={"btn_side " + (this.currentSide == data.id ? 'active-v2' : '')} data-id={data.id}><b>{count}</b>

                                {t(data.name)}</button>
                            )
                          })
                        }
                      </span>
                    }
                    </p>


                  </div>
                }

                {
                  ( views.length > 1 )
                  &&
                  <span className="sep "></span>
                }


                <div className="action-block">

                  <button onClick={ ()=> { this.upload() } } className="btn_standard bf-upload-btn">
                    <IconImageAdd/>
                    {t('upload')}
                  </button>
                  {
                    ( bf_config.features.text != 'false' )
                  &&
                  <button className="btn_standard bf-text-btn"
                          onClick={()=>{ this.addText() }}
                          >
                    <IconTextAdd/>
                    {t('text')}
                  </button>
                  }

                  <button className="btn_standard hide-on-mobi-phone" onClick={ () => { this.toggleBackgroundPicker() } }>
                    <IconFill/>
                    {t('color')}
                  </button>
                  {
                    this.showBackgroundPicker
                    &&
                    <Picker
                      dictionaryStorage={this.props.dictionaryStorage}
                      onChoiceColor={  (color)=> { this.onChoiceColor(color) } }
                      onClickOutside={ ()=> { this.toggleBackgroundPicker() } }
                    >
                    </Picker>
                  }

                </div>
                <span className="sep hide-on-mobi"></span>
                <div className="action-block hide-on-mobi-phone">
                  <Basket config={this.props.config} dictionaryStorage={this.props.dictionaryStorage}/>
                </div>


        </div>);
    }
}


